import { render, staticRenderFns } from "./collectionInfo.vue?vue&type=template&id=5e02c4d1&scoped=true"
import script from "./collectionInfo.vue?vue&type=script&lang=js"
export * from "./collectionInfo.vue?vue&type=script&lang=js"
import style0 from "./collectionInfo.vue?vue&type=style&index=0&id=5e02c4d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e02c4d1",
  null
  
)

export default component.exports